import React from 'react';

const primaryColor = "#4C4C4D";
const secondaryColor = "#E0E0E0";

function getColor(mode: string) {
  return mode === "dark" ? secondaryColor : primaryColor;
}

const DownArrow = function (mode = "light", customColor?: string, customSize?: number): React.JSX.Element {
  const size = customSize || 20;
  const svgWidth = Math.round((customSize || 20) * 0.6); // Maintain aspect ratio
  const svgHeight = Math.round((customSize || 20) * 0.4);
  const fillColor = customColor || getColor(mode);
  
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        width={svgWidth}
        height={svgHeight}
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8527 1.1003C10.9084 1.04767 10.9739 1.00653 11.0455 0.97922C11.1171 0.951911 11.1933 0.93897 11.2699 0.941137C11.3465 0.943304 11.4219 0.960535 11.4919 0.991848C11.5618 1.02316 11.6249 1.06794 11.6775 1.12363C11.7301 1.17932 11.7713 1.24484 11.7986 1.31643C11.8259 1.38802 11.8388 1.46429 11.8367 1.54088C11.8345 1.61747 11.8173 1.69289 11.786 1.76282C11.7547 1.83276 11.7099 1.89584 11.6542 1.94847L6.40419 6.9068C6.29588 7.0092 6.15248 7.06625 6.00344 7.06625C5.85439 7.06625 5.71099 7.0092 5.60269 6.9068L0.352102 1.94847C0.295192 1.89619 0.249235 1.83312 0.216905 1.76293C0.184573 1.69274 0.166512 1.61682 0.163768 1.53959C0.161024 1.46236 0.173654 1.38536 0.200922 1.31305C0.228189 1.24074 0.269553 1.17457 0.32261 1.11838C0.375667 1.0622 0.43936 1.01711 0.509988 0.985749C0.580616 0.954385 0.656772 0.937368 0.734033 0.935685C0.811293 0.934003 0.888118 0.947688 0.960045 0.975947C1.03197 1.00421 1.09757 1.04648 1.15302 1.1003L6.00344 5.68063L10.8527 1.1003Z"
          fill={fillColor}
        />
      </svg>
    </div>
  );
};

const UpArrow = function (mode = "light", customColor?: string, customSize?: number): React.JSX.Element {
  const size = customSize || 20;
  const svgWidth = Math.round((customSize || 20) * 0.6); // Maintain aspect ratio
  const svgHeight = Math.round((customSize || 20) * 0.4);
  const fillColor = customColor || getColor(mode);
  
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        width={svgWidth}
        height={svgHeight}
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.14731 6.9006C1.09162 6.95323 1.02611 6.99437 0.95452 7.02168C0.882928 7.04899 0.806658 7.06193 0.730065 7.05976C0.653473 7.0576 0.578056 7.04036 0.508123 7.00905C0.43819 6.97774 0.375108 6.93296 0.322481 6.87727C0.269854 6.82158 0.228711 6.75606 0.201402 6.68447C0.174093 6.61288 0.161153 6.53661 0.163319 6.46002C0.165486 6.38343 0.182718 6.30801 0.21403 6.23808C0.245343 6.16814 0.290123 6.10506 0.345815 6.05243L5.59581 1.0941C5.70412 0.991705 5.84752 0.93465 5.99656 0.93465C6.14561 0.93465 6.28901 0.991705 6.39731 1.0941L11.6479 6.05243C11.7048 6.10471 11.7508 6.16778 11.7831 6.23797C11.8154 6.30816 11.8335 6.38408 11.8362 6.46131C11.839 6.53854 11.8263 6.61554 11.7991 6.68785C11.7718 6.76016 11.7304 6.82633 11.6774 6.88252C11.6243 6.9387 11.5606 6.98379 11.49 7.01515C11.4194 7.04652 11.3432 7.06353 11.266 7.06522C11.1887 7.0669 11.1119 7.05321 11.04 7.02495C10.968 6.99669 10.9024 6.95443 10.847 6.9006L5.99656 2.32027L1.14731 6.9006Z"
          fill={fillColor}
        />
      </svg>
    </div>
  );
};

const ExapandIcon = function (): React.JSX.Element {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8527 1.1003C10.9084 1.04767 10.9739 1.00653 11.0455 0.97922C11.1171 0.951911 11.1933 0.93897 11.2699 0.941137C11.3465 0.943304 11.4219 0.960535 11.4919 0.991848C11.5618 1.02316 11.6249 1.06794 11.6775 1.12363C11.7301 1.17932 11.7713 1.24484 11.7986 1.31643C11.8259 1.38802 11.8388 1.46429 11.8367 1.54088C11.8345 1.61747 11.8173 1.69289 11.786 1.76282C11.7547 1.83276 11.7099 1.89584 11.6542 1.94847L6.40419 6.9068C6.29588 7.0092 6.15248 7.06625 6.00344 7.06625C5.85439 7.06625 5.71099 7.0092 5.60269 6.9068L0.352102 1.94847C0.295192 1.89619 0.249235 1.83312 0.216905 1.76293C0.184573 1.69274 0.166512 1.61682 0.163768 1.53959C0.161024 1.46236 0.173654 1.38536 0.200922 1.31305C0.228189 1.24074 0.269553 1.17457 0.32261 1.11838C0.375667 1.0622 0.43936 1.01711 0.509988 0.985749C0.580616 0.954385 0.656772 0.937368 0.734033 0.935685C0.811293 0.934003 0.888118 0.947688 0.960045 0.975947C1.03197 1.00421 1.09757 1.04648 1.15302 1.1003L6.00344 5.68063L10.8527 1.1003Z"
        fill="#4C4C4D"
      />
    </svg>
  );
};
const CollapseIcon = function (): React.JSX.Element {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(180)"
    >
      <path
        d="M1.1478 6.90068C1.09211 6.9533 1.0266 6.99445 0.955008 7.02176C0.883416 7.04907 0.807146 7.06201 0.730554 7.05984C0.653961 7.05767 0.578545 7.04044 0.508611 7.00913C0.438678 6.97782 0.375597 6.93304 0.32297 6.87734C0.270342 6.82165 0.2292 6.75614 0.201891 6.68455C0.174582 6.61296 0.161641 6.53669 0.163808 6.46009C0.165974 6.3835 0.183206 6.30809 0.214518 6.23815C0.245831 6.16822 0.290611 6.10514 0.346303 6.05251L5.5963 1.09418C5.70461 0.991781 5.848 0.934727 5.99705 0.934727C6.1461 0.934727 6.2895 0.991781 6.3978 1.09418L11.6484 6.05251C11.7053 6.10479 11.7513 6.16786 11.7836 6.23805C11.8159 6.30824 11.834 6.38415 11.8367 6.46138C11.8395 6.53861 11.8268 6.61562 11.7996 6.68793C11.7723 6.76024 11.7309 6.82641 11.6779 6.88259C11.6248 6.93878 11.5611 6.98386 11.4905 7.01523C11.4199 7.04659 11.3437 7.06361 11.2665 7.06529C11.1892 7.06697 11.1124 7.05329 11.0404 7.02503C10.9685 6.99677 10.9029 6.9545 10.8475 6.90068L5.99705 2.32034L1.1478 6.90068Z"
        fill="#C81E24"
      />
    </svg>
  );
};

export { DownArrow, UpArrow, ExapandIcon, CollapseIcon };
